import React from 'react';

const PrintButton = () => {

    const handlePrint = () => {
        window.print();
    };

    return (
        <div className="print-toolbar no-print">
            <button
                className="print-btn"
                onClick={handlePrint}
            >
                打印表单
            </button>
        </div>
    );
};

export default PrintButton;